import { render, staticRenderFns } from "./ListSaraivaCnpjDisponivelView.vue?vue&type=template&id=f928b23a&"
import script from "./ListSaraivaCnpjDisponivelView.vue?vue&type=script&lang=ts&"
export * from "./ListSaraivaCnpjDisponivelView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports